var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"management-menu columns is-centered is-multiline"},[_c('div',{staticClass:"column is-12 is-8-fullhd"},[_c('div',{staticClass:"columns is-centered is-multiline is-mobile"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }